<div class="form-container">
<form [formGroup]="smsSettingsForm" (ngSubmit)="onSubmit()" class="sms-settings-form">
    <div >
        <div class="flex justify-between items-center">
            <h2 class="text-xl font-semibold">SMS Settings</h2>
            <button mat-icon-button [matTooltip]="'Help with SMS Variables'" (click)="openHelpDialog()">
                <mat-icon>help_outline</mat-icon>
            </button>
        </div>
        
        <div class="form-section">
            <h2>SMS Message Templates</h2>
            
            <div class="message-setup">
                <mat-form-field appearance="outline">
                    <mat-label>Order placed</mat-label>
                    <textarea matInput formControlName="orderPlacedTemplate" rows="4" 
                            placeholder='Enter "order placed" SMS template text. Use {name} for dynamic content'
                            (contextmenu)="onTextareaContextMenu($event, 'orderPlacedTemplate')"></textarea>
                </mat-form-field>
            </div>
            <div class="message-setup">
                <mat-form-field appearance="outline">
                    <mat-label>Confirmation</mat-label>
                    <textarea matInput formControlName="confirmationTemplate" rows="4" 
                            placeholder='Enter "confirmation" SMS template text. Use {name} for dynamic content'
                            (contextmenu)="onTextareaContextMenu($event, 'confirmationTemplate')"></textarea>
                </mat-form-field>
            </div>
            <div class="message-setup">
                <mat-form-field appearance="outline">
                    <mat-label>Confirmation Retry</mat-label>
                    <textarea matInput formControlName="confirmationTemplateRetry" rows="4" 
                            placeholder='Enter "confirmation retry" SMS template text. Use {name} for dynamic content'
                            (contextmenu)="onTextareaContextMenu($event, 'confirmationTemplateRetry')"></textarea>
                </mat-form-field>
            </div>
            <div class="message-setup">
                <mat-form-field appearance="outline">
                    <mat-label>Appointment approved by customer</mat-label>
                    <textarea matInput formControlName="confirmationApprovedTemplate" rows="4" 
                            placeholder='Enter "appointment approved" SMS template text. Use {name} for dynamic content'
                            (contextmenu)="onTextareaContextMenu($event, 'confirmationApprovedTemplate')"></textarea>
                </mat-form-field>
            </div>
            <div class="message-setup">
                <mat-form-field appearance="outline">
                    <mat-label>Appointment rejected by customer</mat-label>
                    <textarea matInput formControlName="confirmationRejectedTemplate" rows="4" 
                            placeholder='Enter "appointment rejected" SMS template text. Use {name} for dynamic content'
                            (contextmenu)="onTextareaContextMenu($event, 'confirmationRejectedTemplate')"></textarea>
                </mat-form-field>
            </div>
            <div class="message-setup">
                <mat-form-field appearance="outline">
                    <mat-label>Route Started</mat-label>
                    <textarea matInput formControlName="routeStartedTemplate" rows="4" 
                            placeholder='Enter "route started" SMS template text. Use {name} for dynamic content'
                            (contextmenu)="onTextareaContextMenu($event, 'routeStartedTemplate')"></textarea>
                </mat-form-field>
            </div>
            <div class="message-setup">
                <mat-form-field appearance="outline">
                    <mat-label>Arriving Soon (next stop)</mat-label>
                    <textarea matInput formControlName="arrivingSoonTemplate" rows="4" 
                            placeholder='Enter "arriving soon" SMS template text. Use {name} for dynamic content'
                            (contextmenu)="onTextareaContextMenu($event, 'arrivingSoonTemplate')"></textarea>
                </mat-form-field>
            </div>
            <div class="message-setup">
                <mat-form-field appearance="outline">
                    <mat-label>Arrived</mat-label>
                    <textarea matInput formControlName="arrivedTemplate" rows="4" 
                            placeholder='Enter "arrived" SMS template text. Use {name} for dynamic content'
                            (contextmenu)="onTextareaContextMenu($event, 'arrivedTemplate')"></textarea>
                </mat-form-field>
            </div>
            <div class="message-setup">
                <mat-form-field appearance="outline">
                    <mat-label>Rating</mat-label>
                    <textarea matInput formControlName="raitingTemplate" rows="4" 
                            placeholder='Enter "raiting" SMS template text. Use {name} for dynamic content'
                            (contextmenu)="onTextareaContextMenu($event, 'raitingTemplate')"></textarea>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Reminder Rating</mat-label>
                    <textarea matInput formControlName="reminderRatingTemplate" rows="4" 
                            placeholder='Enter "reminder raiting" SMS template text. Use {name} for dynamic content'
                            (contextmenu)="onTextareaContextMenu($event, 'reminderRatingTemplate')"></textarea>
                </mat-form-field>
            </div>
            <div class="message-setup">
                <mat-form-field appearance="outline">
                    <mat-label>Good Rating</mat-label>
                    <textarea matInput formControlName="goodRatingTemplate" rows="4" 
                            placeholder='Enter "good rating" SMS template text. Use {name} for dynamic content'
                            (contextmenu)="onTextareaContextMenu($event, 'goodRatingTemplate')"></textarea>
                </mat-form-field>
            </div>
            <div class="message-setup">
                <mat-form-field appearance="outline">
                    <mat-label>Bad Rating</mat-label>
                    <textarea matInput formControlName="badRatingTemplate" rows="4" 
                            placeholder='Enter "bad rating" SMS template text. Use {name} for dynamic content'
                            (contextmenu)="onTextareaContextMenu($event, 'badRatingTemplate')"></textarea>
                </mat-form-field>
            </div>
            <div class="message-setup">
                <mat-form-field appearance="outline">
                    <mat-label>Delayed</mat-label>
                    <textarea matInput formControlName="delayedTemplate" rows="4" 
                            placeholder='Enter "Delayed" SMS template text. Use {name} for dynamic content'
                            (contextmenu)="onTextareaContextMenu($event, 'delayedTemplate')"></textarea>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="form-actions">
        <div class="test-message-section">
            <input matInput formControlName="testJobId" placeholder='Enter a job ID'/>
            <button mat-raised-button color="primary" (click)="testSMS(); $event.preventDefault();" [disabled]="!smsSettingsForm.valid">
                Test SMS
            </button>
        </div>
        <button mat-raised-button color="primary" type="submit" 
                [disabled]="!smsSettingsForm.valid">
            Save SMS Settings
        </button>
    </div>
</form>
</div>

<!-- Help Dialog Template -->
<ng-template #helpDialog>
    <h2 mat-dialog-title>Available SMS Variables</h2>
    <div class="help-content-wrapper">
        <mat-dialog-content>
            <p class="mb-4">You can use these variables in your SMS messages using <a href="https://shopify.github.io/liquid/basics/introduction/">Liquid syntax</a>. <br>For example: <code>Hello {{'{{customer_first_name}}'}}!</code></p>
            
            <div class="grid grid-cols-2 gap-4">
                <div class="flex flex-col gap-2">
                    <div class="help-section-title">Customer Information</div>
                    <div class="help-variables">
                        <div><code>customer_first_name</code> - Customer's first name</div>
                        <div><code>customer_last_name</code> - Customer's last name</div>
                        <div><code>dealer</code> - Dealer information</div>
                        <div><code>hub</code> - Hub information</div>
                        <div><code>order_number</code> - Purchase order number</div>
                        <div><code>address</code> - Customer's address</div>
                    </div>
                </div>
                <br>
                <div class="flex flex-col gap-2">
                    <div class="help-section-title">URLs</div>
                    <div class="help-variables">
                        <div><code>followup_url</code> - Follow-up URL</div>
                        <div><code>summary_url</code> - Summary URL</div>
                        <div><code>public_review_url</code> - Public review URL</div>
                    </div>
                </div>
                <br>
                <div class="flex flex-col gap-2">
                    <div class="help-section-title">Schedule Information</div>
                    <div class="help-variables">
                        <div><code>schedule_date</code> - Full schedule date</div>
                        <div><code>schedule_date_short</code> - Short format date</div>
                        <div><code>schedule_day</code> - Day of the week</div>
                        <div><code>schedule_time</code> - Time of the schedule</div>
                        <div><code>schedule_start</code> - Start time</div>
                        <div><code>schedule_end</code> - End time</div>
                    </div>
                </div>
                <br>
                <div class="flex flex-col gap-2">
                    <div class="help-section-title">Delivery Information</div>
                        <div class="help-variables">
                        <div><code>driver_name</code> - Name of the driver</div>
                        <div><code>stop_number</code> - Stop number</div>
                    </div>
                </div>
            </div>
            
        </mat-dialog-content>
        <mat-dialog-actions class="help-actions">
            <button mat-button mat-dialog-close mat-raised-button color="primary">Close</button>
        </mat-dialog-actions>
    </div>
</ng-template>

<!-- Help Dialog Template -->
<ng-template #smsSimulationDialog>
    <h2 mat-dialog-title>SMS Simulation</h2>
    <div class="help-content-wrapper">
        <mat-dialog-content>
            <div class="flex flex-col gap-4">
                <div *ngIf="smsSimulationData?.messages && getMessageKeys(smsSimulationData.messages).length > 0; else noMessages">
                    <div *ngFor="let messageKey of getMessageKeys()" class="flex flex-col gap-2">
                        <div class="help-section-title">{{ messageKey | titlecase }}</div>
                        <div class="help-variables">
                            <pre style="white-space: pre-wrap; word-break: break-word;">{{ smsSimulationData.messages[messageKey] }}</pre>
                        </div>
                    </div>
                </div>
                <ng-template #noMessages>
                    <div>No messages to display.</div>
                </ng-template>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions class="help-actions">
            <button mat-button mat-dialog-close mat-raised-button color="primary">Close</button>
        </mat-dialog-actions>
    </div>
</ng-template>

<!-- Context Menu Overlay -->
<div *ngIf="showContextMenu" 
     class="context-menu" 
     [style.left.px]="contextMenuX" 
     [style.top.px]="contextMenuY"
     (click)="$event.stopPropagation()">
    <div class="context-menu-header">
        <span>Insert Variable</span>
    </div>
    <div class="context-menu-items">
        <div *ngFor="let item of contextMenuItems" 
             class="context-menu-item"
             (click)="insertVariable(item.value)">
            {{ item.label }}
        </div>
    </div>
</div>